/**
 * @file  footer/content.ts
 * @description  handles the json content to interface mapping
 *
 * @author ogarcia (ozkary)
 *
 */
import { FooterModel } from './footer.model';
// set the footer content per brand
const resources = (async () : Promise<FooterModel> => await import('../../content/footer.json'))();

// export a promise to resolve the dynamic content
// the component awais the promise resolution
export const ContentLoader = resources;
